// Bootstrap
import bootstrap from "bootstrap/dist/js/bootstrap.js";
import {showAlert, showToast} from "./notifications";

export const initInquiryForm = () => {
    const inquiryModalEl = document.getElementById('productInquiryModal');
    const inquiryModalContentEl = document.getElementById('productInquiryModalContent');
    let formEl = null;

    if (!inquiryModalEl) {
        return;
    }

    const inquiryModal = new bootstrap.Modal(inquiryModalEl);

    // Otevření modalu po kliknutí na tlačítka poptávky
    document.querySelectorAll('.product-inquiry-btn, .product-main-inquiry-btn').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            inquiryModal.show(e.target);
        })
    });

    // při otevření modalu formulář inicializujeme formulář
    inquiryModalEl.addEventListener('show.bs.modal', async (e) => {
        const prodName = inquiryModalEl.getAttribute('data-prod-name');
        const prodCode = e.relatedTarget?.getAttribute('data-prod-code');

        if (formEl == null) bindForm();
        await requestForm(true);
        initValues({prodName, prodCode});
    });

    const initValues = ({prodName, prodCode}) => {
        // předvyplníme název a kód produktu
        document.getElementById('product_inquiry_form_productName').value = prodName;
        document.getElementById('product_inquiry_form_productCode').value = prodCode;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        await requestForm(false);
    }

    const bindForm = () => {
        formEl?.removeEventListener('submit', onSubmit);
        formEl = inquiryModalContentEl.querySelector('form');
        formEl.addEventListener('submit', onSubmit)
    }

    /**
     * Načtení formuláře (při init i při odeslání)
     * 200 - načtení formuláře (init)
     * 201 - formulář odeslán
     * 422 - formulář nevalidní
     * @param initForm
     * @returns {Promise<void>}
     */
    const requestForm = async (initForm) => {

        try {
            const action = formEl.getAttribute('action');

            // pri init formuláře použijeme GET (tim resetujeme formular, jeho stav a hodnoty), při submitu POST
            const result = await fetch(action, {
                method: initForm ? "GET" : "POST",
                body: initForm ? null : new FormData(formEl),
                headers: {"X-Requested-With": "XMLHttpRequest"}
            });

            // pokud je init formulare nebo je formulář nevalidní, načteme znovu obsah modalu
            if (result.status === 200 || result.status === 422) {
                inquiryModalContentEl.innerHTML = await result.text();
                bindForm();
            }

            // pokud je formulář odeslán, zobrazíme toast a modal zavřeme
            if (result.status === 201) {
                showToast(window.app.trans('product.inquiry.form.submit.success'), 'success', 5000);
                inquiryModal.hide();
            } else if (result.status === 422) {
                showAlert('#productInquiryModalAlertPlaceholder', window.app.trans('product.inquiry.form.submit.not_valid'), 'danger')
            } else {
                if (!result.ok) showAlert('#productInquiryModalAlertPlaceholder', window.app.trans('product.inquiry.form.submit.failed'), 'danger')
            }
        } catch (e) {
            console.error("Error while requesting inquiry form", e);
            showAlert('#productInquiryModalAlertPlaceholder', window.app.trans('product.inquiry.form.submit.failed'), 'danger')
        }
    }
}

